import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

function EnabledRouteLoader() {
  const { t } = useTranslation(['glossary']);
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        padding: '20px',
        border: '1px solid rgba(0, 0, 0, 0.125)',
        borderRadius: '8px',
        background: '#fff',
      }}
    >
      <CircularProgress />
      <Typography variant="body1">
        {`${t('loading', { ns: 'glossary' })}...`}
      </Typography>
    </Box>
  );
}

export default EnabledRouteLoader;
